import { Component, OnInit, ElementRef, OnDestroy } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

import { Textbox } from './../../models/editors/textbox.model';

import { ApiService } from './../../shared/services/api.service';
import { FormControlService } from './../../shared/services/form-control.service';
import { AlertService } from './../../shared/services/alert.service';
import { atLeastOneLang } from '../../shared/validators/langField.validator';
import { FormDetailBase } from './../../shared/components/base/form-detail/form-detail.base.component';

import { AppointmentCalendar } from './../../models/calendar/calendar.model';
import { Textarea } from './../../models/editors/textarea.model';
import { FieldsRow } from './../../models/editors/fields-row.model';

import { Validators } from '@angular/forms';
import { ContainedFormFields } from './../../models/editors/contained-form-fields.model';
import { TimePicker } from './../../models/editors/timepicker.model';
import { CommunicationService } from './../../shared/services/communication.service';


@Component({
  selector: 'swb-calendar-detail',
  templateUrl: './../../shared/components/base/form-detail/form-detail.base.component.html',
  providers: [FormControlService]
})
export class CalendarDetailComponent extends FormDetailBase<AppointmentCalendar> implements OnInit, OnDestroy {

  public url = 'appointment-calendars';

  protected _redirect = './appointments';

  public entity = new AppointmentCalendar({});

  public get fieldsConfig(): Array<any> {
    return [
      new Textbox({
        key: 'title',
        label: 'Název kalendáře',
        validators: [atLeastOneLang],
        isMultilang: true
      }),
      new Textarea({
        key: 'description',
        label: 'Popisek',
        isMultilang: true,
        wysiwyg: true
      }),
      new Textbox({
        key: 'minute_interval',
        label: 'Interval [min]',
        validators: [Validators.required],
        type: 'number',
        defaultValue: 30
      }),
      new Textbox({
        key: 'email',
        label: 'E-mail, kam posílat notifikace',
        type: 'email'
      }),
      new Textbox({
        key: 'slot_capacity',
        label: 'Kapacita rezervačního okna',
        type: 'number',
        defaultValue: 1
      }),
      new ContainedFormFields({
        key: 'appointment_formfields',
        label: 'Formulářová pole',
        validators: [],
        containedMultilang: true
      }),
      new FieldsRow({
        label: 'Pondělí',
        fields: [
          new TimePicker({
            key: 'monday_from',
            label: 'Od',
            defaultValue: '09:00',
            type: 'time',
            width: 50
          }),
          new TimePicker({
            key: 'monday_to',
            label: 'Do',
            defaultValue: '17:00',
            type: 'time',
            width: 50
          })
        ]
      }),
      new FieldsRow({
        label: 'Úterý',
        fields: [
          new TimePicker({
            key: 'tuesday_from',
            label: 'Od',
            defaultValue: '09:00',
            type: 'time',
            width: 50
          }),
          new TimePicker({
            key: 'tuesday_to',
            label: 'Do',
            defaultValue: '17:00',
            type: 'time',
            width: 50
          })
        ]
      }),
      new FieldsRow({
        label: 'Středa',
        fields: [
          new TimePicker({
            key: 'wednesday_from',
            label: 'Od',
            defaultValue: '09:00',
            type: 'time',
            width: 50
          }),
          new TimePicker({
            key: 'wednesday_to',
            label: 'Do',
            defaultValue: '17:00',
            type: 'time',
            width: 50
          })
        ]
      }),
      new FieldsRow({
        label: 'Čtvrtek',
        fields: [
          new TimePicker({
            key: 'thursday_from',
            label: 'Od',
            defaultValue: '09:00',
            type: 'time',
            width: 50
          }),
          new TimePicker({
            key: 'thursday_to',
            label: 'Do',
            defaultValue: '17:00',
            type: 'time',
            width: 50
          })
        ]
      }),
      new FieldsRow({
        label: 'Pátek',
        fields: [
          new TimePicker({
            key: 'friday_from',
            label: 'Od',
            defaultValue: '09:00',
            type: 'time',
            width: 50
          }),
          new TimePicker({
            key: 'friday_to',
            label: 'Do',
            defaultValue: '17:00',
            type: 'time',
            width: 50
          })
        ]
      }),
      new FieldsRow({
        label: 'Sobota',
        fields: [
          new TimePicker({
            key: 'saturday_from',
            label: 'Od',
            type: 'time',
            width: 50
          }),
          new TimePicker({
            key: 'saturday_to',
            label: 'Do',
            type: 'time',
            width: 50
          })
        ]
      }),
      new FieldsRow({
        label: 'Neděle',
        fields: [
          new TimePicker({
            key: 'sunday_from',
            label: 'Od',
            type: 'time',
            width: 50
          }),
          new TimePicker({
            key: 'sunday_to',
            label: 'Do',
            type: 'time',
            width: 50
          })
        ]
      })
    ];
  }

  protected _saveCallback = () => {
    this._communicationService.reloadSublists();
  }

  constructor(
    _formService: FormControlService,
    _apiService: ApiService,
    _router: Router,
    _alertService: AlertService,
    private _route: ActivatedRoute,
    private _communicationService: CommunicationService
  ) {
    super(
      _formService,
      _apiService,
      _router,
      _alertService
    );
  }

  ngOnInit() {

    if (typeof this._route.snapshot.params['id'] !== 'undefined') {
      this._id = this._route.snapshot.params['id'];
    }

    this._getEntity();

  }

  protected _setupForm(): void {
    this.form = this._formService.toFormGroup(this.fieldsConfig.slice(), this.entity);
    this.formEditors = this._formService.toTemplateInput(this.fieldsConfig.slice(), this.entity);
    this.isInitialized = true;

  }

  public ngOnDestroy(): void {
    // TODO: do something
  }

}
